import axios from "axios";
import ConnUrls from '../Connections/ConnectURL'
import { placeParams } from '../ContextApi/cityContext';


const getAllCategurys = async () => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "categurys");    
    return (dFromF);
}

const getCateguryById = async (id) => {

    let dFromF = await axios.get(ConnUrls.ApiUrl + "categurys/" + id); 
    return (dFromF);
}
const getRestsByCatId = async (id) => {
    let dFromF = await axios.get(ConnUrls.ApiUrl + "RestsByCat/" + id, { params: placeParams() }); // לפי המקום של הלקוח
    return (dFromF);
}



export default {
    getAllCategurys,
    getCateguryById,
    getRestsByCatId
};